@if (isLoading()) {
<div class="loading-overlay">
  <div class="modern-loader"></div>
</div>
}
